import React from "react";
import { SoftSkills } from "./SoftSkills";
import { TechSkills } from "./TeckSkills";

const Skills = () => {
  return (
    <>
      <section>
        <TechSkills />
      </section>
      <section>
        <SoftSkills />
      </section>
    </>
  );
};
export default Skills;
